var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "candidate-navbar",
        staticStyle: { "background-color": "#3b425d" },
      },
      [
        _vm.isShowOnBoardData
          ? _c(
              "button",
              {
                staticStyle: { "background-color": "#18c58b", color: "#fff" },
                attrs: { type: "button" },
                on: { click: _vm.gotToPage },
              },
              [_vm._v(" 報到資料 ")]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticStyle: { "background-color": "#18c58b", color: "#fff" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$common.downloadPersonnelInformationPDF(
                  _vm.resumeType,
                  _vm.matchId
                )
              },
            },
          },
          [_vm._v(" 下載 PDF ")]
        ),
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("返回")]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "step-page" },
      [
        _c(
          "h3",
          { staticClass: "mb-3 text-center", staticStyle: { color: "#fff" } },
          [_vm._v("人事資料表")]
        ),
        _c(
          "el-tabs",
          {
            staticClass: "tab-component",
            attrs: { "tab-position": _vm.windowWidth > 1024 ? "left" : "top" },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "面談背景資料",
                  name: "面談背景資料",
                  lazy: "",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("WorkedInfo", {
                      key: _vm.workedInfoKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "個人資料", name: "個人資料", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填 "
                      ),
                    ]),
                    _c("BaseInfo", {
                      key: _vm.baseInfoKey,
                      ref: "baseInfo",
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                        changePage: _vm.changePage,
                        person: _vm.person,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "工作條件", name: "工作條件", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("WorkCondition", {
                      key: _vm.workConditionKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "學歷", name: "學歷", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(" ** 僅填寫有拿到畢業證書的最高學歷即可 "),
                    ]),
                    _c("Education", {
                      key: _vm.educationKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "工作經歷", name: "工作經歷", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 請由最近工作之公司開始填起（有工廠經驗優先填寫） "
                      ),
                    ]),
                    _c("WorkExperience", {
                      key: _vm.workExperienceKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "專業技能及認證",
                  name: "專業技能及認證",
                  lazy: "",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 請填寫具備的電腦技能、培訓紀錄、證照檢定、工作專長"
                      ),
                      _c("br"),
                      _c("span", { staticClass: "en-text" }, [
                        _vm._v(
                          "*Please fill out if you possess computer skills, training records, work skill"
                        ),
                      ]),
                    ]),
                    _c("Skill", {
                      key: _vm.skillKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "自傳", name: "自傳", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("Autobiography", {
                      key: _vm.autobiographyKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }